import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeObjCPV } from '../models/TypeObjCPV';
import { TypeCPVClass } from '../models/TypeCPVClass';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
@Component({
  selector: 'app-type-objCPV',
  templateUrl: './type-objCPV.component.html'
})
export class TypeObjCPVComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeObjCPV'
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	  
	@Input() cPV : TypeObjCPV;

  constructor() { }

  public ngOnInit() {
  }
  
  
  addtypeCPVClass(){
		this.cPV.objetComplementaire.push(new TypeCPVClass());
	}
  
  removetypeCPVClass(i){
    ArrayPopTools.pop(this.cPV.objetComplementaire, i, this.parentForm, this.getUid());
	}
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

